<template>
    <!--员工收益-->
    <div class="page-wrap">

        <div class="page-body">
            <div class="search-box">
                <ChainStoreSelect v-model="form.search_store_id" />&nbsp;
                <el-date-picker
                        v-model="form.start_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>&nbsp;&nbsp;
                <el-date-picker
                        v-model="form.end_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>&nbsp;&nbsp;
                <el-button type="primary" @click="loadListData">搜索</el-button>&nbsp;&nbsp;
                <el-button-group>
                    <el-button @click="setFormDate(1)">本月</el-button>
                    <el-button @click="setFormDate(2)">上月</el-button>
                </el-button-group>
            </div>
            <div class="summary-body">
                <div class="select-box">
                    <el-select v-model="form.staff_id" placeholder="请选择">
                        <el-option label="所有员工" value="" />
                        <el-option-group
                                v-for="(group, k) in staffList"
                                :key="k"
                                :label="group.label">
                            <el-option
                                    v-for="item in group.list_data"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-option-group>
                    </el-select>
                </div>
                <div class="chart-box">
                    <div class="chart-dom">
                        <ECharts :options="chartOption" ref="ECharts" :autoresize="true" />
                    </div>
                    <div class="table-box">
                        <el-table
                                :data="incomeData"
                                show-summary
                                :summary-method="totalEvent"
                                style="width: 100%">
                            <el-table-column
                                    prop="total_date"
                                    label="时间"
                                    sortable>
                            </el-table-column>
                            <el-table-column
                                    prop="store_name"
                                    label="门店">
                            </el-table-column>
                            <el-table-column label="员工">
                                <template slot-scope="data">
                                    {{data.row.work_id}} {{data.row.staff_name}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="income"
                                    sortable
                                    label="收益">
                                <template slot-scope="data">
                                   ¥{{data.row.income}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作">
                                <template slot-scope="data">
                                    <el-button type="text" @click="showInfo(data.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!--明细-->
        <ChainSummaryStaffData v-model="staffDataShow" :item="staffItem" :staff-id="form.staff_id" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import RightTop from "@/model/RightTop";
    import ECharts from 'vue-echarts';
    import 'echarts/lib/chart/line';
    import 'echarts/lib/component/polar';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/legend';
    import ChainStoreSelect from "@/model/Chain/ChainStoreSelect";
    import ChainSummaryStaffData from "@/model/Chain/ChainSummaryStaffData";

    export default {
        name: "ChainSummaryStaff",
        components: {ChainSummaryStaffData, ChainStoreSelect, RightTop, ECharts},
        data: () => {
            let startDate = new Date();
            startDate.setTime(startDate.getTime() - 1000 * 3600 * 24 * 7);

            let endDate = new Date();
            endDate.setTime(endDate.getTime());

            let data = [];

            for (let i = 0; i <= 360; i++) {
                let t = i / 180 * Math.PI;
                let r = Math.sin(2 * t) * Math.cos(2 * t);
                data.push([r, i])
            }

            return {
                form: {
                    search_store_id: "",
                    start_date: startDate.getFullYear() + "-" + (startDate.getMonth()+1) + "-" + startDate.getDate(),
                    end_date: endDate.getFullYear() + "-" + (endDate.getMonth()+1) + "-" + endDate.getDate(),
                    staff_id: ""
                },
                staffList: [
                    // {
                    //     label: "理发师",
                    //     list_data: [
                    //         {
                    //             id: "1",
                    //             name: "李刚"
                    //         }, {
                    //             id: "2",
                    //             name: "王三"
                    //         }
                    //     ]
                    // }
                ],
                incomeData: [],         //收入数据

                //图表配置
                chartOption: {},
                staffDataShow: false,
                staffItem: {},

                //加载层
                loading: false,
                loadDom: null,
            };
        },
        mounted: function () {
            this.loadStaffList();
            this.loadListData();
        },
        methods: {
            //设置配置
            setOption: function () {
                //解析数据
                let dateArr = [];
                let nameArr = [];
                let seriesArr = [];
                this.incomeData.forEach( val => {
                    dateArr.push(val.total_date);
                    if(!obj.inArray(val.staff_name, nameArr)) {
                        nameArr.push(val.staff_name);
                        seriesArr.push({
                            name: val.staff_name,
                            type: "line",
                            smooth: true,
                            data: [val.income]
                        });
                    }else{
                        for (let i = 0; i < seriesArr.length; i++) {
                            if(seriesArr[i].name === val.staff_name) {
                                seriesArr[i].data.push(val.income);
                            }
                        }
                    }
                });

                this.chartOption = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:nameArr,
                        bottom: 0
                    },
                    xAxis: {
                        type: 'category',
                        data: dateArr
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: seriesArr,
                    animationDuration: 1000
                };

            },
            //获取员工列表
            loadStaffList: function () {
                obj.postData("chain_summary/get_staff_group_tree", {search_store_id: this.form.search_store_id}, res => {
                    if(res.errcode === 0) {
                        this.staffList = res.data;
                    }else{
                        obj.message.error(res.errdesc);
                    }
                });
            },
            //获取数据
            loadListData: function () {
                let postData = this.form;
                this.loading = true;
                obj.postData("chain_summary/get_staff_income_data", postData, res => {
                    if(res.errcode === 0) {
                        this.incomeData = res.data;
                        this.setOption();
                    }else{
                        obj.message.error(res.errdesc);
                    }
                    this.loading = false;
                });
            },
            //修改日期
            setFormDate: function (d) {
                let date = new Date();
                if(d === 1) {
                    date.setDate(1);
                    this.form.start_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
                    let lastDate = new Date();
                    this.form.end_date = lastDate.getFullYear()+"-"+(date.getMonth()+1)+"-"+lastDate.getDate();
                }else if(d === 2){
                    date.setDate(1);
                    this.form.start_date = date.getFullYear()+"-"+date.getMonth()+"-"+date.getDate();
                    date.setMonth(date.getMonth() + 1);
                    let lastDate = new Date(date.getTime() - 1000 * 3600 * 24);
                    this.form.end_date = lastDate.getFullYear()+"-"+lastDate.getMonth()+"-"+lastDate.getDate();
                }
                this.loadListData();
            },
            //显示明细
            showInfo: function (data) {
                this.staffItem = data;
                this.staffDataShow = true;
            },
            //统计计算
            totalEvent: function (params) {
                let {columns, data} = params;
                let sumMoney = 0;
                data.forEach(val => {
                    sumMoney += parseFloat(val.income);
                });
                return ["合计", "", "", "¥" + sumMoney.toFixed(2)];
            }
        },
        watch: {
            loading: function (val) {
                if(val){
                    this.loadDom = this.$loading({
                        lock: false,
                        // text: 'Loading',
                        // spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)',
                        target: ".container"
                    });
                }else{
                    this.loadDom.close();
                }
            },
            "form.staff_id": function ( val ) {
                this.loadListData();
            },
            "form.search_store_id": function (val) {
                this.loadStaffList();
            }
        }
    }
</script>

<style scoped>
    .search-box{
        padding: 16px 0;
        background-color: #ffffff;
    }
    .summary-body{
        padding: 16px 0;
        background-color: #ffffff;
    }
    .table-box{
        margin-top: 60px;
        padding: 16px;
    }
    .echarts {
        width: 100%;
        height: 360px;
    }
</style>
